import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { INTAKE_TEAM_EMAIL } from 'config/constants';
import KhanReportLogoPdf from 'components/shared/KhanReportLogoPdf';
import { globalStyles } from 'config/pdfStyles';

// Create styles
const styles = StyleSheet.create({
  page: {
    // backgroundColor: '#E4E4E4',
    fontSize: 10,
    color: "#333"
  },
  section: {
    flexDirection: 'row',
    margin: 10,
    padding: 10,
  },
  header: {
    alignItems: "center",
    justifyContent: "center",
    // textAlign: "center"
  },
  logo: {
    width: "20%",
  },
  fontBold: {
    fontFamily: "Helvetica-Bold"
  },
  templateHeading: {
    fontSize: "15px",
    marginBottom: "10px",
  },
  templateContainer: {
    flexDirection: "column",
  },
  templateField: {
    paddingVertical: "10px",
  }
});

// Create Document Component
export const ReferenceLetterDoc = ({ data, date }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={[styles.section, styles.header]}>
          <Image
            style={styles.logo}
            src={logo}
          />
        </View>
        <View style={[styles.section]}>
          <Text style={styles.fontBold}>
            Created Date:
          </Text>
          <Text>
            {" "}
            29/11/2024
          </Text>
        </View>
        <View style={[styles.section, styles.templateContainer]}>
          <Text style={[styles.fontBold, styles.templateHeading]}>
            To Whom It May Concern,
          </Text>
          {"\n"}
          {data?.length > 0 && (
            data.map((item, index) => (
              <>
                {"\n"}
                <Text key={index} style={styles.templateField}>
                  {item?.text}
                </Text>
              </>
            ))
          )}
        </View>
        <View style={[styles.section]}>
          <Text style={{ fontSize: "10px" }}>
            The intake team may be contacted at: {INTAKE_TEAM_EMAIL}
          </Text>
        </View>

        {/* Branding */}
        <View style={[globalStyles.section]}>
          <KhanReportLogoPdf />
        </View>
      </Page>
    </Document>
  )
};

export const DownloadLink = () => (
  <div>
    <PDFDownloadLink document={<ReferenceLetterDoc />} fileName="somename.pdf">
      {({ blob, url, loading, error }) =>
        loading ? 'Loading document...' : 'Download now!'
      }
    </PDFDownloadLink>
  </div>
);